<template>
  <div style="width: 100%; height: 100%;display:flex">
    <div class="mapWrap" >
      <iframe id="mapframe" src="../../../static/EvMap/Airline.html?name=John" width="100%" height="100%" style="border: 0px"></iframe>
    </div>

    <div class='changeAirSpace'>
      <!-- 右侧 -->
      <div class="airSpaceBtnOne">
<!--        <div
          title="空域"
          class="chooseBtn"
          :class="airSpaceChecked ? 'active' : ''"
          @click=""
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                airSpaceChecked
                  ? 'kong_yu_click'
                  : 'kong_yu_normal'
              }.png`)
            "
            alt=""
          />
        </div>-->
        <div
          title="要素"
          class="chooseBtn"
          :class="shibeiChecked ? 'active' : ''"
          @click="
            shibeiChecked = !shibeiChecked;
            equip=!equip
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                shibeiChecked ? 'she_bei_click' : 'she_bei_normal'
              }.png`)
            "
            alt=""
          />
        </div>
        <div
          title="航线"
          class="chooseBtn"
          :class="airPointLineChecked ? 'active' : ''"
          @click="
            airPointLineChecked = !airPointLineChecked;
            airPointLine = !airPointLine;
            btClick.airline= airPointLine?btClick.airline:false;
            handleBtClick('airPointLine',airPointLine);
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                airPointLineChecked ? 'fei_xing_click' : 'fei_xing_normal'
              }.png`)
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class='changeAirSpace1'>
      <!-- 右侧 -->
      <div class="airSpaceBtn" style="width: 100%;height: 100%;">

        <div v-show="area" class="area">
          <div
            class="chooseBtn"
            :class="btClick.space ? 'Active' : 'noActive'"
            @click=""
          >
            <div>空域列表</div>
          </div>
          <div class='changeWithOpenXianArea'></div>
        </div>
        <div v-show="equip" class="equip">
          <div class="chooseBtn" :class="btClick.building.show ? 'Active' : 'noActive'" @click="
              btClick.building.show= !btClick.building.show;
              handleBtClick('building',btClick.building);">
            <span class="point building"> </span>
            <div>障碍物</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.forbidden.show ? 'Active' : 'noActive'"
            @click="
              btClick.forbidden.show= !btClick.forbidden.show;
              handleBtClick('forbidden',btClick.forbidden);"
          >
            <span class="point videoPoint"> </span>
            <div>禁飞区</div>
          </div>
          <div class="chooseBtn" :class="btClick.road.show ? 'Active' : 'noActive'" @click="
              btClick.road.show= !btClick.road.show;
              handleBtClick('road',btClick.road);">
            <span class="point road"> </span>
            <div>路网</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.river.show ? 'Active' : 'noActive'" @click="
              btClick.river.show= !btClick.river.show;
              handleBtClick('river',btClick.river);"
          >
            <span class="point river"> </span>
            <div>河道</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.grass.show ? 'Active' : 'noActive'"  @click="
              btClick.grass.show= !btClick.grass.show;
              handleBtClick('grass',btClick.grass);"
          >
            <span class="point grass"> </span>
            <div>绿化</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.weather.show ? 'Active' : 'noActive'"
            @click="
              btClick.weather.show= !btClick.weather.show;
              handleBtClick('weather',btClick.weather);"
          >
            <span class="point weather"> </span>
            <div>气象</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.electric.show ? 'Active' : 'noActive'"
            @click="
              btClick.electric.show= !btClick.electric.show;
              handleBtClick('electric',btClick.electric);"
          >
            <span class="point navigationPoint"> </span>
            <div>电磁</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.population.show ? 'Active' : 'noActive'"
            @click="
              btClick.population.show= !btClick.population.show;
              handleBtClick('population',btClick.population);"
          >
            <span class="point communicationPoint"> </span>
            <div>人口密度</div>
          </div>

          <div class='changeWithOpenXianArea'>

          </div>
        </div>
        <div v-show="airPointLine" class="airPointLine">
          <div
            class="chooseBtn"
            :class="showLineGenerate ? 'Active' : 'noActive'" @click="
              showLineGenerate= !showLineGenerate"
          >
            <div>航线规划</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.airline ? 'Active' : 'noActive'" @click=""
          >
            <div>航线列表</div>
          </div>

          <div class='changeWithOpenXianArea'>

          </div>
        </div>
      </div>
    </div>


    <div style="width: 300px;height: 30px; z-index: 10; user-select: none">
      <el-select v-model=level placeholder="请选择" @change="(val)=>{changeLevel(level)}">
        <el-option style="margin-left: 10px"
          v-for="item in levelOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>


    <div id="chooseAirspace" v-show="showLineGenerate">
      <div class="airspaceTitle"><span>航线规划</span></div>
      <div class="close" @click="close()">
        <img src="../../assets/img/2dmap/jiantou_xiashoulong.png" alt=""/>
      </div>
      <el-form
        :model="airAlineInfo"
        ref="airAlineInfo"
        label-width="120px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-row :gutter="100">
          <el-col :span="15">
            <el-form-item class="select" label="起点：" prop="type">
              <el-input
                v-model="airAlineInfo.startpt"
                type="text"
                placeholder="请填写起点坐标(经,纬,高)"
                @change="handleBtClick('changepoint',{coordinateStr:airAlineInfo.startpt,index: 0, name:'航线起点'})"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="30">
            <el-button   class="button" @click="addFirsting= !addFirsting;handleBtClick('addpoint',{name:'航线起点',index:0})">{{ addFirsting ? '请在地图点击' : '选择起点' }}
            </el-button>
            <el-button class="button"   style="margin-left: 25px" @click="addMiddlePoint()">
              添加途径点
            </el-button>
          </el-col>
        </el-row>
        <el-row class="coordinateRow" v-if="airAlineInfo.airlineCoordinateArr.length> 0">
          <el-form-item class="coordinate"
                        v-for="(coordinate, index) in airAlineInfo.airlineCoordinateArr"
                        :label="`途径点 ${index+1}`"
                        :key="coordinate.key"
                        :prop="`airlineCoordinateArr.${index}.value`"
          >
            <el-input style="width: 51.5%" v-model="coordinate.value" placeholder="经度，纬度,高度以逗号分隔"
                      @change="handleBtClick('changepoint',{coordinateStr:coordinate.value,index: index+1, name:'途径点'+(index+1)})">
            </el-input>
            <el-button  style="margin-left: 12.7%" class="button" @click="addMiddling= !addMiddling;handleBtClick('addpoint',{name:'途径点'+(index+1),index:(index+1)})">{{ addMiddling ? '请在地图点击' : '地图选点' }}
            </el-button>
            <el-button  style="margin-left: 3.5%" class="button" @click="delMiddlePoint(index)">删除
            </el-button>
          </el-form-item>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="15">
            <el-form-item class="select" label="终点：" prop="type">
              <el-input
                v-model="airAlineInfo.endpt"
                type="text"
                placeholder="请填写终点坐标(经,纬,高)"
                @change="handleBtClick('changepoint',{coordinateStr:airAlineInfo.endpt,index: 999, name:'航线终点'})"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="30">
            <el-button   class="button" @click="addLasting= !addLasting;handleBtClick('addpoint',{name:'航线终点',index:999})">{{ addLasting ? '请在地图点击' : '选择终点' }}
            </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="15">
            <el-form-item class="select" label="航线高度：" prop="type">
              <el-input
                v-model="airAlineInfo.lineHeight"
                type="text"
                placeholder="非必填,填写后会修改所有航点为统一高度"
                @change="lineHeightChange(airAlineInfo.lineHeight)"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="12">
            <el-form-item class="select" label="规划方案" prop="type">
              <el-select v-model="gererateway" placeholder="请选择规划方案">
                <el-option
                  v-for="item in gereratewayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  style="padding-left: 10px"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="select" label="规划层级" prop="type">
              <el-select v-model="level" placeholder="请选择规划层级">
                <el-option
                  v-for="item in levelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  style="padding-left: 10px"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="footer">
          <el-col>
            <el-button   class="button" @click="cancel()">取消
            </el-button>
            <el-button class="button"   style="margin-left: 25px" @click="generate()">开始规划
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import PlanDetail from "../../common/PlanDetail";
import Empty from "../../common/Empty.vue";
export default {
  name: "ThreedAirline",
  data() {
    return {
      level:11,
      levelOptions:[{value:9,label:'网格层级9'},{value:10,label:'网格层级10'},{value:11,label:'网格层级11'}],
      gererateway:0,
      gereratewayOptions:[
        {value:0,label:'最短距离'},
        {value:1,label:'避障绕行'},
        {value:2,label:'沿路网'},
        {value:3,label:'沿河道'}],
      addFirsting: false,
      addLasting: false,
      addMiddling: false,
      airSpaceChecked: false,
      shibeiChecked: false,
      airPointLineChecked: false,
      area: false,
      equip: false,
      airPointLine: false,
      airAlineInfo: {
        startpt: "",
        endpt: "",
        airspacePointArry: '',
        airlineCoordinateArr: [],
        center: '',
        radius: '',
        id: null,
        lineHeight:null,
      },
      showLineGenerate:false,
      btClick:{
        building:{
          id:2,
          name:"壹中心及智慧园建筑网格",
          show:false,
          level:11,
          paraName: '上海市北独立建筑',
          material: [255/255, 149/255, 97/255, 0.05],
          outlineColor: [255/255, 149/255, 97/255, 0.2],
        },
        road:{
          id:4,
          name:"市北路网",
          show:false,
          level:11,
          paraName: '市北路网',
          material: [192/255, 240/255, 237/255, 0.2],
          outlineColor: [192/255, 240/255, 237/255, 0.6],
        },
        river:{
          id:5,
          name:"市北河道",
          show:false,
          level:11,
          paraName: '市北河道',
          material: [30/255,144/255,255/255, 0.2],
          outlineColor: [30/255,144/255,255/255,0.6],
        },
        grass:{
          id:6,
          name:"市北绿地",
          show:false,
          level:11,
          paraName: '市北绿地',
          material: [124/255,252/255,0,0.1],
          outlineColor: [124/255,252/255,0,0.4],
        },
        weather: {
          level:11,
          show:false,
        },
        electric:{
          level:11,
          show:false,
        },
        population:{
          level:11,
          show:false,
        },
        forbidden:{
          level:11,
          show:false,
        },
      }
    };
  },
  mounted() {
    let _this= this;
    window.addEventListener("message", function (event){
      let data= event.data;
      if (data.code== 0){
        // 起点选择完毕
        _this.airAlineInfo.startpt = data.data.coordinateStr;
        _this.addFirsting= false;
        return;
      }
      if (data.code== 999){
        // 终点选择完毕
        _this.airAlineInfo.endpt = data.data.coordinateStr;
        _this.addLasting= false;
        return;
      }
      if (data.code>0){
        if (_this.airAlineInfo.airlineCoordinateArr[data.code-1]){
          _this.airAlineInfo.airlineCoordinateArr[data.code-1].value= data.data.coordinateStr;
        }
        _this.addMiddling= false;
      }
    }, false);
  },
  methods:{
    sendMessageToIframe(code , data){
      let message = {code:code, data:data};
      let iframe = document.getElementById('mapframe');
      if (iframe.contentWindow) {
        // 发送消息到iframe
        iframe.contentWindow.postMessage(message, '*'); // 注意目标来源地址
      }
    },
    lineHeightChange(height) {
      if (this.airAlineInfo.startpt){
        let start = this.airAlineInfo.startpt.split(',').map(Number);
        if (start.length== 3){
          this.airAlineInfo.startpt= start[0]+","+start[1]+","+height;
          this.handleBtClick('changepoint',{coordinateStr:this.airAlineInfo.startpt,index: 0, name:'起点'})
        }
      }

      for (let i=0; i<this.airAlineInfo.airlineCoordinateArr.length; i++){
        let pt=this.airAlineInfo.airlineCoordinateArr[i];
        if (pt.value){
          let coord= pt.value.split(',').map(Number);
          if (coord.length== 3){
            pt.value= coord[0]+","+coord[1]+","+height;
            this.handleBtClick('changepoint',{coordinateStr:pt.value,index: i+1, name:'途径点'+(i+1)})
          }
        }
      }

      if (this.airAlineInfo.endpt){
        let end = this.airAlineInfo.endpt.split(',').map(Number);
        if (end.length== 3){
          this.airAlineInfo.endpt= end[0]+","+end[1]+","+height;
          this.handleBtClick('changepoint',{coordinateStr:this.airAlineInfo.endpt,index: 999, name:'终点'})
        }
      }
    },
    handleBtClick(key, value){
      let data={key:key, value:value};
      this.sendMessageToIframe(1, data);
    },
    close() {
      this.showLineGenerate=false
    },
    delMiddlePoint(index) {
      this.airAlineInfo.airlineCoordinateArr.splice(index,1);
      this.handleBtClick('delpoint');
      if (this.airAlineInfo.startpt){
        let start = this.airAlineInfo.startpt.split(',').map(Number);
        if (start.length== 3){
          this.handleBtClick('changepoint',{coordinateStr:this.airAlineInfo.startpt,index: 0, name:'起点'})
        }
      }

      for (let i=0; i<this.airAlineInfo.airlineCoordinateArr.length; i++){
        let pt=this.airAlineInfo.airlineCoordinateArr[i];
        if (pt.value){
          let coord= pt.value.split(',').map(Number);
          if (coord.length== 3){
            this.handleBtClick('changepoint',{coordinateStr:pt.value,index: i+1, name:'途径点'+(i+1)})
          }
        }
      }

      if (this.airAlineInfo.endpt){
        let end = this.airAlineInfo.endpt.split(',').map(Number);
        if (end.length== 3){
          this.handleBtClick('changepoint',{coordinateStr:this.airAlineInfo.endpt,index: 999, name:'终点'})
        }
      }

    },
    cancel() {
      this.handleBtClick('delpoint');
      this.airAlineInfo.startpt=null;
      this.airAlineInfo.endpt=null;
      this.airAlineInfo.airlineCoordinateArr=[];
      this.showLineGenerate=false;
    },
    addMiddlePoint(){
      this.airAlineInfo.airlineCoordinateArr.push({value: ''})
    },
    changeLevel(level){
      for (let key in this.btClick){
        this.btClick[key].level= level;
      }
    },
    generate(){
      let ptArr= [];
      if (this.airAlineInfo.startpt==''|| this.airAlineInfo.endpt==''){
        return;
      }
      let start = this.airAlineInfo.startpt.split(',').map(Number);
      if (start.length!= 3){
        return;
      }
      let end = this.airAlineInfo.endpt.split(',').map(Number);
      if (end.length!= 3){
        return;
      }
      ptArr.push({x:start[0],y:start[1],z:start[2]});
      for (let item of this.airAlineInfo.airlineCoordinateArr){
        if (item.value== ''){
          return;
        }
        let coord= item.value.split(',').map(Number);
        if (coord.length!= 3){
          return;
        }
        ptArr.push({x:coord[0],y:coord[1],z:coord[2]})
      }
      ptArr.push({x:end[0],y:end[1],z:end[2]});

      let param= {
        level: this.level,
        pointList: ptArr,
        std: 1,
        type: this.gererateway
      }
      this.handleBtClick("generate", param);

    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}


#dashboardIndex {
  z-index: 3;
  width: 100%;
  height: 100%;
  position: relative;
}
/* 两侧以及底部顶部z-index 为4  header为3 高于地图 */
.mapWrap{

  z-index: 2;
  position: absolute;
  top:73px;
  left:0;
  width: 100%;
  height: calc(100% - 73px);
  overflow: hidden;
}
.headerContent{
  pointer-events:none;
  z-index: 3;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: end;
  padding: 16px 22px 0 17px;
  //position: relative;
  position: absolute;
}
@media screen and (max-width: 1920px) {
  .headerContent{
    height: 144px;
    background-image: url("../../assets/img/dashboard/header.png");
  }
  .headerMiddle{
    font-size: 66px;
    line-height: 60px;
  }
}
@media screen and (min-width: 2000px) {
  .headerContent{
    height: 240px;
    background-image: url("../../assets/img/dashboard/header_2880.png");
  }
  .headerMiddle{
    line-height: 100px;
    font-size: 100px;
  }
}
.headerLeft{
  position: absolute;
  left: 17px;
  top: 16px;
  z-index: 5;
  display: flex;
}
.headerBtn{
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0,0,0,0.18);
  line-height: 40px;
  cursor: pointer;
}
.headerMiddle{
  //width: 1388px;
  position: absolute;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16,9,0,0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.headerRight{
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 10px;
}

.contentWrap{
  position: absolute;
  top: 72px;
  height: calc(100% - 72px);
  width: 100%;
}
.leftContent{
  top: 0;
  left: 0;

}
.rightContent{
  top: 0;
  right: 0;
}
.leftContent,
.rightContent{
  z-index: 4;
  background: rgba(1,10,18, 0.68);
  height: 100%;
  //width: 20%;
  width: 400px;
  position: absolute;
  display: flex;
  flex-direction: column;
  //overflow: auto;
}

.rightContent{
  right: 0;

}
.bottomContent{
  z-index: 4;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: calc(100% - 800px);
  justify-content: space-around;
}
.bottomBtn,.bottomBtnClick{
  cursor: pointer;
  text-align: center;
  line-height: 74px;
  width: 233px;
  height: 74px;
  font-size: 32px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 1.6px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
}
.bottomBtn{
  background-image: url("../../assets/img/dashboard/normal.png");
}
.bottomBtnClick{
  background-image: url("../../assets/img/dashboard/click.png");
}
.contentItem{
  height: 66%;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
.contentItem10{
  height: 33%;
  //min-height: 100px;
  display: flex;
  flex-direction: column;
}
.contentItem30{
  flex: 30;
  max-height: 26%;
  display: flex;
  flex-direction: column;
}
.itemTitle{
  height: 50px;
  background-image: url("../../assets/img/2dmap/pop_bg.png");
  background-size: 80% 38px;
  padding-left: 44px;
  background-repeat: no-repeat;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 12px;
}
.barChart,.lineChart{
  flex: 1;
  margin-top: 11px;
}
.inspectionContentWrap{
  padding: 23px 21px 0 29px;
  height: calc(100% - 50px);
}
#patrolHistory{
  background-image: url('../../assets/img/dashboard/shuju_bg2.png');
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
#patrolHistory .historyItem{
  width: 110px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
#patrolHistory .historyItem:not(:last-child){
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;

}
#patrolDefect{
  padding: 13px 23px 23px 34px;
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}
#patrolDefect .dayItem{
  width: 120px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
.data{
  //margin-bottom: 5px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
}
.text{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.checkData{
  border-bottom: 2px solid ;
  border-image: linear-gradient(0deg, rgba(255, 200, 119, 0.99), rgba(255, 200, 119, 0.00) 49%, rgba(238, 175, 84, 0.00)) 2 2;
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-bottom: 8px;
}
.separate{
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.alarmWrap{
  height: calc(100% - 50px);
  padding: 0 33px 23px 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alarmContentWrap{
  display: flex;
  justify-content: space-between;
}
.alertItem{
  background-size: 100%;
  position: relative;
  width: 140px;
  height: 132px;
}
.alertItemText{
  position: absolute;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  bottom: 6px;
  left: 34px;
}
.alertItemFigure{
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1px 1.73px 5px 2px rgba(20,10,0,0.68);
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}
#heiFeiItem{
  background-image: url("../../assets/img/dashboard/hei_fei.png");
}
#chongTuItem{
  background-image: url("../../assets/img/dashboard/chong_tu.png");
}
#pianHangItem{
  background-image: url("../../assets/img/dashboard/pian_hang.png");
}
#zhengChangItem{
  background-image: url("../../assets/img/dashboard/zheng_chang.png");
}
.basic{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 50px);
  padding: 30px 34px 27px 24px;
}
.equipment{
  display: flex;
}
.up{
  background-image: url(../.././assets/img/dashboard/tubiao_chengse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  margin-right: 60px;
  position: relative;
}
.watch{
  background-image: url(../.././assets/img/dashboard/tubiao_jinse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  position: relative;
}
.datas{
  position: absolute;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  //text-align: left;
  color: #ffffff;
  //z-index: 99;
  left: 57px;
  top: 10px;
}
.equipment .texts{
  min-width: 130px;
  position: absolute;
  left: 58px;
  top: 40px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  //text-align: left;
  color: #ebebeb;
  //z-index: 99;
}
.states{
  display: flex;
}
.states .texts{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.down{
  width: 159px;
  height: 132px;
  background: rgba(23,11,1,0.50);
  border: 2px solid rgba(255,200,119,0.30);
  margin-top: 5px;
}
.stateone{
  display: flex;
  margin-top: 12px;
}
.txt{
  width: 100%;
  height: 42%;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
  padding-left: 11px;
  padding-top: 15px;
}
.numbers{
  width: 45px;
  height: 17px;
  line-height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-left: 45px;
}
.numberstwo{
  width: 20px;
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ff5555;
  margin-left: 45px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.lineChartWrap{
  flex:1;
  height: calc(100% - 92px);
}
.linkBtn{
  position: relative;
}
.linksGroup{
  position: absolute;
  left: 35px;
  top:-60px;
  width: 170px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.linksGroup a{
  line-height: 22px;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  font-size: 24px;
  font-family: 'PangMenZhengDao-3', 'PangMenZhengDao-3-Regular';
  font-weight: 400;
  text-decoration: underline;
  text-align: left;
  color: #ffc877;
}
.taskcontent_2d{
  padding: 5px 10px;
  height: 100%;
  overflow: auto;
}
.taskSearchBox{
  margin-bottom: 12px;
}

>>>.taskSearchBox .el-input__inner {
  color: #FFFFFF;
  border-radius: 0;
  border: none;
}

.taskSearchBox >>>input{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: calc(100% - 5px);
  height: 32px;
  background: rgba(0, 174, 255, 0.5);
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
}
.taskSearchBox  /deep/.el-input__icon{
  height: 32px;
  //border: 1px solid red;
  right: 10px;
  line-height: 38px;
  cursor: pointer;

}
.taskSearchBox input{

}
.taskSearchBox input >>>i{
  //border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}
.task-item_2d {
  margin: 16px 0;
  cursor: pointer;
}
.task-item_2d .common{
  background: rgba(1, 10, 18, 0.68);
  height: 38px;
  color: #FFFFFF;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 10px
}

.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}

.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}

.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}
.taskWrap{
  background: rgba(1, 10, 18, 0.68);
  border-radius: 6px;
  padding: 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100% - 62px)
}

.common .firstSpan{
  min-width: 90px;
}
.common .secondSpan{
  min-width: 50px;
}
.common .thirdSpan{
  min-width: 40px;
}
.common .itemDetail{
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}
/*.task-item_2d  .donePlan{
  background: #220c03;
}
.task-item_2d  .prePlan{
  background: #2d0a0a;
}
.task-item_2d  .executePlan{
  background: #2f1d0b;
}*/
.prePlan:hover{
  box-shadow: 0px 0px 6px 1px #ff5555 inset;
}
.executePlan:hover{
  box-shadow: 0px 0px 6px 1px #ffc877 inset;
}
.donePlan:hover{
  box-shadow: 0px 0px 6px 1px deepskyblue inset;
}
.task-item_2d .planeBtns{
  padding-right: 5px;
  display: flex;
}
.emptyContent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  width: 100%;
  background: #170b01;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
}
.planeBtns .planTobtn{
  display: flex;
  align-items: center;
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1001;
}
.planeBtns .planTobtn:not(:last-child){
  margin-right: 6px;
}
.planTobtn img{
  width: 26px;
  height: 26px;
}
.planeBtns .planTobtn span {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 35px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  z-index: 100;
}
.planeBtns .planTobtn:hover span {
  display: block;
}
.listAll_2d{
  height: calc(100% - 44px);
  padding: 0 10px;
  background: rgba(1, 10, 18, 0.50);
  overflow: auto;
}
.emptyWrap{
  width: 100%;
  height: calc(100% - 44px);
}
#rightOverlay {
  width: 400px !important;
}
*{
  user-select: none;
}
.flyTop {
  padding: 13px 23px 23px 34px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 22px 18px 22px;
  width: 350px;
  height: 92px;
  /* background-image: url("../../assets/img/2dmap/shuju_bg.png"); */
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}

.flyTopTop div:nth-child(1) {
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  text-align: left;
}

.flyTopTop div:nth-child(2) {
  width: 100px;
  height: 15px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.canChangeFigure {
  height: 40px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;

}
.flyTop .flyText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
#fenge {
  display: block;
  width: 70px;
  height: 0;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.flyTop .unActiveFigure {
  margin-top: 4px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
  margin-bottom: 11px;
}
.flyTop .erectFenge {
  width: 0px;
  height: 74px;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.RightBottomBottom {
  width: 306px;
  height: 38px;
  /* background: rgba(23, 11, 1, 0.50); */
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  background-image: url(../../../src/assets/img/2dmap/paihang_bg.png);
}
.shortShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 28px;
  margin-right: 6px;
}
.rightBottomBottomText {
  width: 100px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.processStyle {
  width: 155px;
  height: 6px;
  margin-right: 10px;
  margin-left: 10px;
}
.RightBottomBottomFigure {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.titleShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 38px;
  margin-right: 6px;
}
.inspectionContentWrap .rightBottomTop .titleBgL {
  background: linear-gradient(90deg, rgba(255, 140, 77, 0.50) 0%, rgba(255, 140, 77, 0.00) 100%);
}

.inspectionContentWrap .rightBottomTop .titleBgR {
  background: linear-gradient(90deg, rgba(255, 85, 85, 0.50) 0%, rgba(255, 85, 85, 0.00) 100%);
}
.inspectionContentWrap .rightBottomTop .titleBgL,
.inspectionContentWrap .rightBottomTop .titleBgR {
  width: 140px;
  height: 38px;
  display: flex;
  align-items: center;
}
.ordinaryText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  margin-right: 10px;
}
.contentFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}
.ordinaryFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ebebeb;
}
.openLeftBtn{
  cursor: pointer;
  position: absolute;
  left: 5px;
  top:8px;
  z-index: 10;
}
.closeLeftBtn{
  cursor: pointer;
  position: absolute;
  right: -50px;
  top:2px;
}

.changeWithOpen {
  position: absolute;
  //top: 495px;
  //top: 470px;
  top: calc(50% + 40px );
  transform: translateY(-50%);
  right: 370px;
  width: 48px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

/* 右侧 */
.changeAirSpace {
  position: absolute;
  //top: 495px;
  top: 460px;
  right: 12px;
  width: 50px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

.airSpaceBtnOne .chooseBtn {
  width: 100%;
  height: 48px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  z-index: 1004;
}

.changeWithOpen1 {
  position: absolute;
  //top: 495px;
  top: calc(50% + 40px );
  transform: translateY(-50%);
  right: 405px;
  width: 156px;
  overflow: auto;
  //height: 620px;
  max-height:  calc(100% - 360px);
  cursor: pointer;
  z-index: 1003;
  background: transparent;

}

.changeAirSpace1 {
  position: absolute;
  //top: 495px;
  top: 250px;
  right: 56px;
  width: 150px;
  height: 620px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

.airSpaceBtn .chooseBtn {
  width: 100%;
  height: 34px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  padding-left: 15px;
  margin-bottom: 10px;
  z-index: 1004;
}


.changeWithOpen1 .airSpaceBtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.airSpaceBtn {
  position: relative;
}

.airSpaceBtn .chooseBtn img {
  position: absolute;
  top: 10px;
  right: 0px;
  margin-bottom: 15px;
}

.changeWithOpen1 .airSpaceBtn .chooseBtn {
  width: 100%;
}

.changeWithOpen .airSpaceBtn .chooseBtn {
  margin-bottom: 24px;
}

.area {
  position: relative;
  width: 156px;
  height: 45px;
}

.equip {
  position: relative;
  width: 156px;
  height: 350px;
}

.population {
  position: relative;
  width: 156px;
  height: 45px;
}
.airPointLine{
  position: relative;
  width: 156px;
  height: 90px;
}
.Active {
  background-image: url(../../assets/img/2dmap/er_ji_click.png);
  background-repeat: no-repeat;
}

.noActive {
  background-image: url(../../assets/img/2dmap/er_ji_normal.png);
  background-repeat: no-repeat;
}

.changeWithOpenXianArea {
  position: absolute;
  //top: 495px;
  /* top: 5px; */
  top: 0;
  right: 40px;
  width: 5px;
  height: 100%;
  cursor: pointer;
  z-index: 1003;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}
.chooseBtn div {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  /* margin-bottom: 5px; */
}


.changeAirSpace1 .airSpaceBtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.changeWithOpenXianEquip {
  position: absolute;
  //top: 495px;
  top: 0;
  right: 40px;
  width: 5px;
  height: 250px;
  cursor: pointer;
  z-index: 1003;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}

.changeWithOpenXianAirPointLine {
  position: absolute;
  //top: 495px;
  top: 0;
  /* todo */
  right: 40px;
  width: 5px;
  height: 120px;
  cursor: pointer;
  z-index: 1003;
  background-size: contain;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}


.task-item_2d_realTask{
  display: flex;
  width: 100%;
  height: auto;
  //line-height: 38px;
  background: #170b01;
  border-radius: 6px;
  margin-bottom: 6px;
  align-items: center;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  box-sizing: border-box;
  padding-left: 5px;
}
.listAll_2d .warn_2d{
  background: linear-gradient(
    90deg,
    rgba(255, 150, 0, 0.8),
    rgba(71, 160, 255, 0.2)
  );
}
.listAll_2d .alarm_2d {
  background: linear-gradient(
    90deg,
    rgba(218, 0, 1, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}

.chooseBtn .point{
  position: absolute;
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  left: 5px;
  margin: auto;
}
.weather{
  background: #ffb11b;
}
.building{
  background: rgb(255, 149, 97);
}
.road{
  background: rgb(192, 240, 237);
}
.river{
  background: rgb(30,144,255);
}
.grass{
  background: rgb(124,252,0);
}
.videoPoint{
  background: #ff391f;
}
.navigationPoint{
  background: #00b1fb;
}
.communicationPoint{
  background: #00ffae;
}

.airspaceTitle {
  background-image: url("../../assets/img/2dmap/kong_yu_guan_li.png");
  background-repeat: no-repeat;
  height: 50px;
  text-align: left;
  padding-left: 27px;
  background-size: 80% 38px;
  width: 100%;
}

.airspaceTitle span{
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 400;
  text-align: left;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  text-shadow: -2px 0px 3.68px 0.16px rgba(16, 1, 0, 0.50);
  color: #ffffff;
}

#chooseAirspace .close {
  cursor: pointer;
  position: absolute;
  //right: -30px;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  width: 38px;
  height: 38px;
  //background: rgba(15, 86, 115, 0.4);
}

#chooseAirspace {
  position: absolute;
  bottom: 8px;
  //left: 800px;
  left: 30%;
  min-width: 240px;
  width: 48%;
  //height: 20%;
  z-index: 1004;
  background: rgba(1, 10, 18, 0.68);
  border-radius: 6px;
  padding: 10px 30px 10px 10px;
  //background-image: url("../../assets/img/2dmap/bac3.png");
  background-size: 100% 100%;
  opacity: 0.9;
}

>>>.el-form--label-left .el-form-item__label {
   text-align: center;
   color: white;
}

>>>.select .el-select {
  width: 100% !important;
}

>>>.el-scrollbar .el-scrollbar__wrap{
  overflow: hidden;
}

>>>.select .el-select .el-input__inner {
  color: #fff;
  height: 30px;
  background: rgba(10, 5, 0, 0.70);

}

>>>.select .el-select .el-input__suffix {
  right: 10px;
}

>>> .el-input__inner {
  /* border: 1px solid #1D6DC8; */
  /* background-color: #153862; */
  border: unset !important;
  background: rgba(10, 5, 0, 0.70);
  border-radius: 6px;
  color: #fff;
  height: 32px;
  //cursor: not-allowed;
}

.button {
  width: 100px;
  height: 35px;
  color: white;
  background: transparent;
  background-size: 100% 100%;
  background-image: url("../../assets/img/2dmap/pop_btn_normal.png");
}

.button:hover {
  background-image: url("../../assets/img/2dmap/pop_btn_click.png");
}

.footer {
  height: 40px;
  margin-top: 20px;
}

.footer .el-form-item__content {
  margin-left: 0 !important;
}

.coordinate {
  width: 100%;
  text-align: left;
}

>>> .el-scrollbar {
  overflow: hidden;
  margin-left: 10px;
}

.coordinateRow {
  max-height: 150px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/home/ThreedAirline.vue